var map = {
	"./3400_10dB_day.mp3": 1122,
	"./3400_10dB_night.mp3": 897,
	"./3400_SAMPLE3_C37_F500_A7W55_02_Max_Night_8s.mp3": 280,
	"./3400_SAMPLE3_C70_F650_A7W55_02_Max_Day_6s_8s.mp3": 7832,
	"./7000_A7W35_4kW_01_Baseline_C240_F55_7C1_night.mp3": 6385,
	"./7000_A7W35_4kW_01_Baseline_C298_F60_7C1_day.mp3": 4802,
	"./7400i_A7W55_5kW_Max_Day_Mode_C320_F4.mp3": 8285,
	"./7400i_A7W55_5kW_Night_Mode_C156_F3.mp3": 9395,
	"./8118_9kW_Baseline_C298_F60_7C1.mp3": 2209,
	"./8118_9kW_Baseline_C360_F80_7C1.mp3": 8676,
	"./CS5800_5_5kW_Max_Day_1m_2ch_06.mp3": 7387,
	"./CS5800_5_5kW_Max_Night_1m_2ch_06.mp3": 1862,
	"./CS6800-day.mp3": 6297,
	"./CS6800-night.mp3": 210,
	"./Hintergrund-Sound_NACHT.mp3": 1315,
	"./Hintergrund-Sound_TAG.mp3": 3402,
	"./bedroom-day.mp3": 9966,
	"./birds.mp3": 1019,
	"./compress5000.wav": 8524,
	"./fan-night-1.wav": 131,
	"./fan-night-2.wav": 9581,
	"./fan-night-3.wav": 2587,
	"./fan.wav": 2744,
	"./night-ambient.mp3": 3526,
	"./silence.mp3": 5318
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9403;